import { useRef, useState } from 'react'
import { useTranslation } from '@/utils/useTranslation'
import tw from 'twin.macro'
import zxcvbn from 'zxcvbn'
import TextField from '@/components/forms/fields/text-field'

function SectionPasswordTest() {
  const { t } = useTranslation()
  const [pass, setPass] = useState('')
  const renderCount = useRef(0)
  renderCount.current += 1

  const getScoreValues = (score) => {
    if (score < 2) {
      return { score: t('very weak'), scoreColor: tw`text-melonRed` }
    }
    if (score < 3) {
      return { score: t('weak'), scoreColor: tw`text-amberOrange` }
    }
    if (score < 4) {
      return { score: t('good'), scoreColor: tw`text-tealBlue` }
    }
    return { score: t('strong'), scoreColor: tw`text-primaryBlue` }
  }

  // const stringPass = pass.join('');
  const zxcvbnObj = zxcvbn(pass)

  const { score, scoreColor } = getScoreValues(zxcvbnObj.score)

  const crackTime = zxcvbnObj.crack_times_display.offline_slow_hashing_1e4_per_second as string
  const lang = {
    'less than a second': t('less than a second'),
    second: t('second'),
    seconds: t('seconds'),
    minute: t('minute'),
    minutes: t('minutes'),
    hour: t('hour'),
    hours: t('hours'),
    day: t('day'),
    days: t('days'),
    week: t('week'),
    weeks: t('weeks'),
    month: t('month'),
    months: t('months'),
    year: t('year'),
    years: t('years'),
    century: t('century'),
    centuries: t('centuries'),
  }
  const matches = crackTime.match(/^(\d+) (\w+)$/)
  const crackTimeLang = matches && matches.length === 3 ? `${Number(matches[1])} ${lang[matches[2]]}` : lang[crackTime]

  return (
    <div tw="lg:max-w-8xl m-auto lg:px-9" id="Password-Strength-Testing-Tool">
      <div tw="bg-primaryBlue px-5 lg:px-32 py-10 lg:pt-16 lg:pb-20 lg:rounded-4xl">
        <div tw="text-center text-white pb-2 lg:pb-6">
          <h2>{t('Password Strength Testing Tool')}</h2>
          <p>{t('Think you have a strong password? Find out below.')}</p>
        </div>
        <div tw="bg-white rounded-4xl">
          <div tw="max-w-5xl mx-auto p-5 md:(p-12)">
            <TextField
              tw="font-mono text-xl my-2 sm:(text-4xl my-5) truncate"
              css={scoreColor}
              type="text"
              name="password"
              label={t('Evaluate your password:')}
              value={pass}
              onUpdate={(val) => setPass(val)}
              autoFocus
            />

            <div tw="flex flex-wrap justify-between pt-2 lg:pt-8">
              <div tw="w-full md:w-1/2">
                <h5 tw="mb-0">{t('Your password strength')}:</h5>
                <div tw="font-bold" css={scoreColor}>
                  {renderCount.current && score}
                </div>
              </div>

              <div tw="w-full md:w-1/2">
                <h5 tw="mb-0">{t('Estimated time to crack')}:</h5>
                <div tw="font-bold" css={scoreColor}>
                  {renderCount.current && crackTimeLang}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionPasswordTest
